'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

var _setCurrentStage = require('./setCurrentStage');

var _setCurrentStage2 = _interopRequireDefault(_setCurrentStage);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id) {
  return function (dispatch, getState) {
    var currentStage = getState().getIn(['stages', 'ui', feis_id, 'currentStage']);
    // prefer the cached version
    if (currentStage) return;

    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisStagesPrefix)(feis_id)
      },
      types: ['GET_STAGES_START', 'GET_STAGES', 'GET_STAGES_ERROR']
    })).then(function () {
      var stages = (0, _paths.getStages)(getState(), feis_id);
      var currentStewardingDay = getState().getIn(['stages', 'ui', feis_id, 'currentStewardingDay']);

      var stagesForCurrentDay = stages.map(function (id) {
        return (0, _paths.getStage)(getState(), id);
      }).filter(function (stage) {
        return stage.get('dt') === currentStewardingDay;
      });

      return stagesForCurrentDay.size > 0 && dispatch((0, _setCurrentStage2.default)(feis_id, stagesForCurrentDay.get(0).get('id')));
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/getStagesSetCurrent.js
// module id = 245
// module chunks = 0